import { render, staticRenderFns } from "./QrCodeScanner.vue?vue&type=template&id=12070bda&scoped=true&"
import script from "./QrCodeScanner.vue?vue&type=script&lang=js&"
export * from "./QrCodeScanner.vue?vue&type=script&lang=js&"
import style0 from "./QrCodeScanner.vue?vue&type=style&index=0&id=12070bda&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12070bda",
  null
  
)

export default component.exports